export const EVENT_ID = 'SOOGAH_EVENT_ID';
export const FLAVOURS_LIST = 'SOOGAH_FLAVOURS_LIST';
export const TRANSACTIONS_LIST = 'SOOGAH_TRANSACTIONS_LIST';
export const EVENT_CODES_LIST = 'SOOGAH_EVENT_CODES_LIST';
